import React, { useRef } from 'react';
import noPreviewImage from '../../../assets/images/PostNoPreview.png';
import noPreviewReelImage from '../../../assets/images/StoriesNoPreview.png';
import styles from '../../../styles/usageRights.module.css';
import { PostType } from './types';

interface MediaThumbnailProps {
  type: PostType;
  thumbnail: string;
}

function MediaThumbnail({ thumbnail, type }: MediaThumbnailProps) {
  const img = useRef<HTMLImageElement>(null);

  const onImageLoadError = () => {
    if (img?.current) {
      if (type === 'reel') {
        img.current.src = noPreviewReelImage;
      } else {
        img.current.src = noPreviewImage;
      }
    }
  };

  return (
    <div className={styles.mediaThumbnailContainer}>
      <img src={thumbnail} alt="" className={styles.mediaImage} onError={onImageLoadError} ref={img} />
    </div>
  );
}

export default MediaThumbnail;
